<template>
    <div class="modal-error">
        <h1>{{ $t("shared.errors.ui.unhandled-error-happened") }}: {{ errorMessage }}</h1>
        <!--  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="160px" height="160px"
            viewBox="0 0 45 45" version="1.1">
            <title>red_status</title>
            <defs>
                <path
                    d="M8.43205769 38.1906149C2.90905516 38.17423 0.630739568 34.2579195 3.34303632 29.4437542L16.0266682 6.93106212C18.7390819 2.11668929 23.1497045 2.11171534 25.8729434 6.91091845L38.7464812 29.5981394C41.4720152 34.4013872 39.1981662 38.2818882 33.6812163 38.2655212L8.43205769 38.1906149Z"
                    id="path-1" />
                <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-2">
                    <feOffset dx="-2" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
                    <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
                    <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1" />
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.245216259 0" type="matrix"
                        in="shadowBlurOuter1" />
                </filter>
                <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-3">
                    <feOffset dx="0" dy="1" in="SourceAlpha" result="shadowOffsetInner1" />
                    <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1"
                        result="shadowInnerInner1" />
                    <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.4 0" type="matrix"
                        in="shadowInnerInner1" />
                </filter>
            </defs>
            <g id="red-exclamation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                transform="translate(0.000000, -1.000000)">
                <g id="Rectangle-134">
                    <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1" />
                    <use fill="#cb1212" fill-rule="evenodd" xlink:href="#path-1" />
                    <use fill="black" fill-opacity="1" filter="url(#filter-3)" xlink:href="#path-1" />
                    <use xlink:href="#path-1" />
                </g>
                <line class="exclamation" x1="21" y1="11" x2="21" y2="25" stroke-linecap="round" stroke="#fff"
                    stroke-width="4" />
                <circle class="dot" cx="21" cy="32" r="2" fill="#fff" />
            </g>
        </svg>

-->
        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 442 381">
            <defs>
            </defs>
            <g id="Background_Complete">
                <g>
                    <g>
                        <g>
                            <path class="st5"
                                d="M426.1,181.6c3.3-11.3,2.7-22.8-1-33,2.9-4.1,5.1-8.7,6.6-13.7,6.7-23.2-5.5-47.4-27.5-56.1-4.2-30.4-25.8-57-57.3-66.1-24.8-7.2-50.3-1.8-69.7,12.4-4.8-5.1-11-9-18.3-11.1-21.8-6.3-44.5,6.3-50.8,28.1-1.1,3.6-1.6,7.3-1.6,10.9-21.9,4.4-40.7,20.6-47.3,43.5-6,20.6-.7,41.8,12.2,57.1-1.7,3-3,6.2-4,9.7-7.1,24.7,7.1,50.6,31.9,57.7,8.2,2.4,16.4,2.4,24.1.5,9.1,12.5,22.3,22.3,38.3,26.9,20.6,5.9,41.7,2.2,58.5-8.4,7.5,17.5,13.7,43.7.4,69.5,48.3-4.7,83.3-51.1,76.1-93.6,13.8-6.3,24.9-18.4,29.4-34.2Z" />
                            <path class="st1"
                                d="M333.3,299.7c-.3,0-.5-.1-.7-.3-.3-.3-.4-.6-.3-1,6.8-23.7.6-46.5-5.8-61.4l-3.2-7.5-6.9,4.4c-10.5,6.6-22.5,10.2-34.8,10.2s-12.1-.9-18-2.6c-14-4-26-12.4-34.6-24.3l-2.8-3.8-4.6,1.1c-6.7,1.7-13.8,1.5-20.5-.4-10.2-2.9-18.6-9.6-23.7-18.9-5.1-9.3-6.3-20-3.4-30.1.8-2.8,2-5.6,3.4-8.2l2.3-4.2-3.1-3.7c-11.9-14.1-15.9-33-10.8-50.7,5.7-19.8,21.8-34.6,42-38.6l5.6-1.1v-5.7c0-3.1.5-6.1,1.4-9.1,4.2-14.5,17.6-24.6,32.7-24.6s6.4.5,9.5,1.3c5.8,1.7,11,4.8,15.2,9.2l4.2,4.4,5-3.6c12.5-9.2,27.9-14.2,43.3-14.2s13.7,1,20.3,2.9c27.7,8,48.3,31.7,52.3,60.3l.6,4,3.8,1.5c19,7.5,29.1,28,23.4,47.7-1.2,4.2-3.1,8.1-5.6,11.7l-2.1,3,1.2,3.4c3.3,9.3,3.6,19.3.9,28.8-3.8,13.2-13.1,24-25.6,29.7l-4.9,2.2.9,5.3c3,18.1-2.4,37.9-15,54.3-10.5,13.7-25.1,23.8-41.2,28.5,0,0-.2,0-.3,0ZM323.8,227.1c0,0,.2,0,.3,0,.3,0,.5.3.6.6l3.7,8.6c6.4,14.8,12.6,37.3,6.4,60.9,15-4.8,28.6-14.4,38.4-27.2,12.2-16,17.5-35.2,14.6-52.8l-1-6c0-.4.2-.9.6-1.1l5.6-2.6c11.9-5.5,20.9-15.9,24.5-28.5,2.6-9.1,2.3-18.6-.8-27.5l-1.4-3.9c-.1-.3,0-.6.1-.9l2.4-3.4c2.4-3.4,4.1-7.1,5.3-11.1,5.4-18.7-4.2-38.1-22.2-45.2l-4.3-1.7c-.3-.1-.6-.4-.6-.8l-.6-4.6c-3.9-27.8-23.8-50.9-50.8-58.7-6.5-1.9-13.1-2.8-19.8-2.8-15,0-29.9,4.9-42.1,13.8l-5.7,4.1c-.4.3-1,.2-1.3-.1l-4.8-5.1c-3.9-4.1-8.8-7.1-14.3-8.6-2.9-.8-5.9-1.3-8.9-1.3-14.2,0-26.8,9.5-30.8,23.2-.8,2.8-1.2,5.6-1.3,8.5v6.5c0,.5-.4.9-.9,1l-6.3,1.3c-19.5,3.9-35,18.2-40.4,37.2-4.9,17-1,35.3,10.4,48.8l3.6,4.2c.3.3.3.8.1,1.1l-2.7,4.8c-1.4,2.5-2.5,5.1-3.3,7.8-2.8,9.6-1.6,19.8,3.2,28.6,4.9,8.8,12.8,15.2,22.5,17.9,6.3,1.8,13.1,2,19.4.4l5.2-1.3c.4-.1.8,0,1.1.4l3.2,4.4c8.3,11.5,19.9,19.6,33.5,23.5,5.7,1.6,11.6,2.5,17.5,2.5,11.9,0,23.6-3.4,33.8-9.8l7.9-5c.2-.1.3-.2.5-.2Z" />
                        </g>
                        <path class="st1"
                            d="M263.2,133.6l-26.8-4.2.4-2.7c.7-4.6,1.8-8.2,3.3-10.9s3.4-5,5.8-7.1c2.4-2,7.7-5.5,15.7-10.3,4.3-2.5,6.6-5.1,7-7.6.4-2.6,0-4.7-1.4-6.4-1.3-1.7-3.5-2.8-6.6-3.2-3.3-.5-6.3.2-8.8,2-2.5,1.9-4.5,5.5-6,10.9l-26.8-7.6c2.5-9.9,7.4-17.4,14.8-22.6,7.3-5.1,17.6-6.7,30.7-4.6,10.3,1.6,18.2,5,23.8,10.3,7.7,7.1,10.7,15.5,9.2,25.1-.6,4-2.3,7.7-5.1,11.1-2.8,3.4-8,7.2-15.7,11.5-5.3,3-8.8,5.6-10.4,7.7-1.6,2.1-2.7,5-3.3,8.6ZM234.4,136.4l28.7,4.5-3.9,25.3-28.7-4.5,3.9-25.3Z" />
                        <path class="st1"
                            d="M331.6,172.8l-14.9-12.1,1.2-1.5c2.1-2.5,4-4.4,5.9-5.5,1.9-1.1,3.9-1.9,6.1-2.2,2.2-.4,6.6-.6,13.2-.7,3.5,0,5.8-.7,7-2.2,1.2-1.4,1.6-2.9,1.4-4.4-.2-1.5-1.2-2.9-2.9-4.3-1.9-1.5-3.9-2.1-6.1-1.9-2.2.2-4.7,1.8-7.5,4.5l-13.7-14.2c5-5.2,10.7-8,17-8.6,6.3-.5,13.1,2.1,20.4,8.1,5.7,4.6,9.3,9.5,10.9,14.7,2.2,7.1,1.1,13.3-3.3,18.6-1.8,2.2-4.1,3.9-7,4.9-2.9,1.1-7.4,1.6-13.6,1.5-4.3,0-7.4.3-9.1,1-1.7.7-3.4,2.1-5.1,4.1ZM313,164.3l15.9,12.9-11.4,14.1-15.9-12.9,11.4-14.1Z" />
                        <path class="st1"
                            d="M335.8,86.2l-6.4-8.8.9-.6c1.5-1.1,2.8-1.8,4-2.2,1.2-.3,2.4-.5,3.7-.4,1.3.1,3.7.6,7.4,1.5,1.9.5,3.3.4,4.2-.2.8-.6,1.3-1.4,1.4-2.2.1-.8-.2-1.8-1-2.8-.8-1.1-1.8-1.7-3.1-1.9-1.3-.2-2.9.3-4.8,1.4l-5.5-9.8c3.5-2.1,7.1-2.9,10.6-2.2,3.5.6,6.9,3.1,10.1,7.4,2.5,3.4,3.7,6.6,3.9,9.7.2,4.2-1.3,7.5-4.5,9.8-1.3,1-2.8,1.5-4.6,1.7-1.8.2-4.3-.2-7.7-1.2-2.4-.7-4.1-.9-5.1-.8-1,.1-2.2.6-3.4,1.5ZM326.8,78.8l6.9,9.4-8.3,6.1-6.9-9.4,8.3-6.1Z" />
                    </g>
                    <g>
                        <path class="st9"
                            d="M87.3,211c-8.3,0-16.6-2.3-24-6.7-10.1-6-17.3-15.4-19.8-25.8-8.2-.6-15.8-4.6-20.9-11.2-3.7-4.7-5.8-10.3-6.1-16.3-2.2-1.5-4.1-3.3-5.7-5.4-7.9-10.2-6.9-24.4,2.2-33.3-3.8-16.3,2.2-33.3,15.4-43.6,10.3-8,23.5-10.9,36.3-7.8,1.5-3.4,3.8-6.3,6.7-8.6,4.7-3.6,10.5-5.2,16.4-4.5,5.9.7,11.2,3.7,14.8,8.4,1.1,1.4,2,3,2.8,4.6,12-2,24.1,2.7,31.6,12.4,6.7,8.6,8.7,19.9,5.4,30.3,1.3,1.1,2.5,2.4,3.5,3.7,8.5,11,6.5,26.8-4.4,35.3-3.3,2.6-7.3,4.3-11.5,5-2.2,8.2-6.9,15.2-13.5,20.4-8.4,6.6-19.2,9.3-29.8,7.6-.1,9.7,2.2,22.9,13,32.3.2.2.3.5.3.8,0,.3-.3.5-.5.6-4,1.2-8.1,1.7-12.3,1.7ZM54.7,61.4c-9,0-17.8,3-25.2,8.7-12.8,10-18.6,26.6-14.7,42.4,0,.3,0,.6-.2.8-8.9,8.4-9.9,21.9-2.4,31.5,1.6,2,3.5,3.8,5.7,5.2.2.1.3.4.4.6.2,5.8,2.2,11.2,5.8,15.8,4.9,6.3,12.3,10.2,20.3,10.6.4,0,.7.3.7.6,2.2,10.2,9.2,19.4,19.2,25.4,10.3,6.1,22.5,8,33.6,5.1-10.7-10-12.7-23.7-12.5-33.5,0-.2.1-.4.3-.6.2-.1.4-.2.6-.2,10.4,2,21.1-.6,29.4-7.1,6.5-5.1,11.1-12,13.1-20.1,0-.3.3-.5.7-.6,4.1-.6,8-2.2,11.2-4.7,10.3-8,12.1-22.8,4.2-33.1-1.1-1.4-2.3-2.7-3.7-3.8-.3-.2-.4-.5-.2-.9,3.3-10.1,1.5-21-5-29.4-7.3-9.3-19-13.8-30.7-11.7-.4,0-.7-.1-.9-.5-.7-1.7-1.7-3.3-2.8-4.8-3.4-4.4-8.3-7.1-13.8-7.8-5.5-.7-10.9.8-15.3,4.2-2.9,2.2-5.1,5.2-6.5,8.6-.1.4-.5.6-.9.5-3.5-.9-6.9-1.3-10.4-1.3Z" />
                        <path class="st5"
                            d="M59.6,127.3l-13.8,3.3-.3-1.4c-.6-2.4-.7-4.3-.5-5.9.2-1.6.7-3.1,1.4-4.6.8-1.5,2.6-4.1,5.6-8.1,1.6-2.1,2.2-3.8,1.9-5.1-.3-1.3-1-2.3-1.9-2.8-1-.6-2.2-.6-3.8-.3-1.7.4-3,1.3-3.9,2.7-.9,1.4-1.1,3.6-.8,6.5l-14.5,1.6c-.7-5.3.2-9.9,2.7-13.9,2.5-3.9,7.2-6.7,14-8.3,5.3-1.2,9.8-1.1,13.6.3,5.1,1.9,8.3,5.4,9.4,10.4.5,2.1.4,4.2-.3,6.4-.7,2.2-2.5,5.1-5.3,8.7-2,2.5-3.2,4.4-3.5,5.8-.4,1.3-.3,2.9.1,4.8ZM46.2,134.4l14.8-3.5,3.1,13-14.8,3.5-3.1-13Z" />
                        <path class="st5"
                            d="M94.8,98.2l-9.6-2.9.3-1c.5-1.6,1.1-2.9,1.8-3.8.7-.9,1.5-1.7,2.5-2.3,1-.6,3.1-1.6,6.3-2.9,1.7-.7,2.7-1.5,3-2.4s.2-1.7-.2-2.4c-.4-.7-1.1-1.2-2.3-1.5-1.2-.4-2.3-.3-3.3.3-1,.6-1.9,1.8-2.8,3.7l-9.4-4.2c1.4-3.5,3.6-6,6.6-7.5,2.9-1.5,6.8-1.5,11.5-.1,3.7,1.1,6.4,2.8,8.2,5,2.4,3,3.1,6.2,2.1,9.7-.4,1.4-1.2,2.7-2.4,3.8-1.2,1.1-3.3,2.2-6.3,3.4-2.1.8-3.5,1.6-4.2,2.3-.7.7-1.2,1.7-1.6,3ZM84.1,97.7l10.3,3.1-2.8,9.1-10.3-3.1,2.8-9.1Z" />
                    </g>
                </g>
            </g>
            <g id="Background_Simple" class="st6">
                <g>
                    <path class="st10"
                        d="M33.8,34.3c-95.7,62,62.1,91.1,102.8,124.7,29.2,24.1,18.8,76.3,63.9,105.4,47.4,30.5,117,30,152.3,12.8,53.3-26,52.2-142.7-34.6-184.2-65.9-31.5-115.2,15.4-182.9-9.8C92.8,67.5,85.9.6,33.8,34.3Z" />
                    <path class="st2"
                        d="M33.8,34.3c-95.7,62,62.1,91.1,102.8,124.7,29.2,24.1,18.8,76.3,63.9,105.4,47.4,30.5,117,30,152.3,12.8,53.3-26,52.2-142.7-34.6-184.2-65.9-31.5-115.2,15.4-182.9-9.8C92.8,67.5,85.9.6,33.8,34.3Z" />
                </g>
            </g>
            <g id="Shadow">
                <ellipse id="_x3C_Path_x3E_" class="st7" cx="209" cy="355.2" rx="193.9" ry="11.3" />
            </g>
            <g id="Question_Marks">
                <g>
                    <path class="st10"
                        d="M111,196.5l-9.8,4.5-.4-1c-.8-1.7-1.2-3.1-1.3-4.3,0-1.2,0-2.4.4-3.6.4-1.2,1.4-3.5,3-6.9.9-1.8,1.1-3.1.7-4.1-.4-.9-1-1.6-1.8-1.8-.8-.3-1.8-.1-2.9.4-1.2.6-2.1,1.4-2.5,2.6-.4,1.2-.3,2.8.4,4.9l-10.6,3.3c-1.3-3.9-1.3-7.4,0-10.8,1.3-3.3,4.4-6.1,9.2-8.3,3.8-1.7,7.2-2.3,10.2-1.8,4.1.7,7,2.8,8.6,6.3.7,1.5.9,3.1.7,4.8-.2,1.7-1.1,4.2-2.7,7.3-1.1,2.2-1.7,3.8-1.8,4.8,0,1,.2,2.2.8,3.6ZM102,203.7l10.5-4.8,4.2,9.3-10.5,4.8-4.2-9.3Z" />
                    <path class="st10"
                        d="M86.6,218.7l-5,6.8-.7-.5c-1.2-.9-2-1.7-2.5-2.5-.5-.8-.9-1.7-1.1-2.6-.2-1-.4-2.9-.6-5.8,0-1.5-.4-2.6-1.1-3-.7-.5-1.3-.7-2-.5-.6.1-1.3.6-1.8,1.4-.6.8-.9,1.8-.7,2.7.2,1,.9,2,2.1,3.2l-6,6.3c-2.4-2.1-3.7-4.6-4.1-7.3-.4-2.8.7-5.8,3.1-9.1,1.9-2.6,4-4.3,6.3-5.1,3.1-1.1,5.8-.7,8.3,1.1,1,.7,1.8,1.7,2.3,3,.5,1.3.8,3.2.9,6,0,1.9.3,3.2.6,4,.3.7,1,1.5,1.9,2.1ZM83.3,227.1l5.4-7.3,6.4,4.7-5.4,7.3-6.4-4.7Z" />
                </g>
            </g>
            <g id="Character">
                <g>
                    <path class="st10"
                        d="M193.1,351.6c-1.6,0-3.2-.9-4-2.4-4-7.8-9.1-16.9-18.2-26.7-1.1-1.2-1.4-2.8-1-4.3,3.4-11.7,8.7-27.7,8.7-27.9.8-2.4,3.3-3.6,5.7-2.8,2.4.8,3.6,3.3,2.8,5.7,0,.1-4.6,13.9-7.9,25.2,8.4,9.5,13.5,18.5,17.8,26.8,1.1,2.2.3,4.9-1.9,6-.7.3-1.4.5-2.1.5Z" />
                    <polygon class="st4" points="200.6 355.2 165.8 355.2 184.2 344.8 199.7 345.4 200.6 355.2" />
                    <path class="st4"
                        d="M110.7,273c-1.8,0-3.4-1-4.1-2.8-.9-2.3.1-4.9,2.4-5.9,2.6-1.1,3-3.7,3-3.8.2-2,1.7-3.6,3.7-4,1.1-.2,2.1-.5,3.3-.8,6.1-1.8,13.6-4,37.3,2.7,23.4-13.1,23.6-37.6,23.6-38.7,0-2.5,2-4.5,4.5-4.5h0c2.5,0,4.5,2,4.5,4.4,0,1.3-.1,32.1-30,47.5-1,.5-2.2.6-3.3.3-22.6-6.5-29-4.7-34.1-3.2-.5.1-.9.3-1.4.4-1.1,2.8-3.4,6.1-7.6,7.9-.6.2-1.1.3-1.7.3Z" />
                    <path class="st10"
                        d="M163.1,240.9c-8.5-33.8-31.2-121.1,41.5-126.4,65.2-4.8,83.1,82,87.4,112,2.5,17.5,3.4,33.4,3.5,45.8.2,16-11.1,29.8-26.8,33-35.5,7.2-69.1,8.2-91.7-.7-6.1-2.4-9.8-8.7-9.2-15.2.9-9.7.9-26.4-4.7-48.6Z" />
                    <path class="st8"
                        d="M292,226.5c-4.1-28.3-20.2-107-76.7-112-6.6-.6-13,2.7-16.1,8.5-2.5,4.9-2.4,10.8,1.3,16.6,12.4,19.3,42.1,86,37.6,122.3-2,16.5-12.4,29.7-3.4,48.3,10.9-.9,22.3-2.6,33.9-5,15.7-3.2,26.9-17,26.8-33-.1-12.4-1-28.3-3.5-45.8Z" />
                    <path class="st4"
                        d="M282.2,272.8c-.2,0-.4-.2-.4-.4-.2-15.5-1.4-30.8-3.5-45.8-10.8-74.7-39.9-112.4-84.1-109.2-.2,0-.5-.2-.5-.4,0-.2.2-.5.4-.5,44.8-3.3,74.2,34.7,85.1,109.9,2.2,15,3.4,30.4,3.5,45.9,0,.2-.2.5-.4.5h0Z" />
                    <path class="st10"
                        d="M284.3,351.6c-1.6,0-3.2-.9-4-2.4-4-7.8-9.1-16.9-18.2-26.7-1.1-1.2-1.4-2.8-1-4.3,3.4-11.7,8.7-27.7,8.7-27.9.8-2.4,3.3-3.6,5.7-2.8,2.4.8,3.6,3.3,2.8,5.7,0,.1-4.6,13.9-7.9,25.2,8.4,9.5,13.5,18.5,17.8,26.8,1.1,2.2.3,4.9-1.9,6-.7.3-1.4.5-2.1.5Z" />
                    <path class="st4"
                        d="M274.9,214.9c-1.6,0-3.2-.9-4-2.4-1.1-2.2-.3-4.9,1.9-6.1h0c.9-.5,20.4-11.1,25.9-36.8-13-5.4-36.4-17.7-41.5-23.9-.5-.6-.8-1.3-1-2.1-.1-.7-1-6,1-11l-2.4-4.6c-1.1-2.2-.3-4.9,1.9-6,2.2-1.1,4.9-.3,6,1.9l3.4,6.6c.7,1.4.7,3.1-.2,4.4-1.1,1.7-1.2,4.3-1.1,5.9,5.8,5.2,29,17.5,40.4,21.8,2,.7,3.2,2.8,2.9,4.9-5.1,32.8-30.1,46.3-31.2,46.8-.7.3-1.4.5-2.1.5Z" />
                    <path class="st4"
                        d="M260.6,145.1c-.4,0-.8-.1-1.2-.4-1-.7-1.3-2.1-.7-3.1.2-.2,3.9-5.8,9.5-7.3,1.2-.3,2.4.4,2.7,1.6s-.4,2.4-1.6,2.7c-3.9,1.1-6.9,5.4-6.9,5.5-.4.7-1.1,1-1.9,1Z" />
                    <polygon class="st4" points="291.8 355.2 257 355.2 275.4 344.8 290.9 345.4 291.8 355.2" />
                    <g>
                        <ellipse class="st1" cx="217" cy="199.8" rx="23.9" ry="21.5"
                            transform="translate(-16.8 19.9) rotate(-5.1)" />
                        <path class="st4"
                            d="M217.5,200.1c1.8,6.4.4,12.3-3,13.3-3.5,1-7.8-3.3-9.6-9.7s-.4-12.3,3-13.3,7.8,3.3,9.6,9.7Z" />
                        <path class="st4"
                            d="M189.8,203.9c15.1-1.9,45-10.5,49.9-13.9-3.9-11.4-22-21.1-38.1-15.6-14.6,4.9-11.8,29.5-11.8,29.5Z" />
                        <path class="st4"
                            d="M192.7,211.2c18.7-3.6,43.1-9.5,50.1-13.4-.4,12.2-4,24.6-23.1,28.8-15.6,3.4-27-15.4-27-15.4Z" />
                    </g>
                    <g>
                        <path class="st1"
                            d="M183,210c.6,9.6-6.1,16.1-15,14.7-8.8-1.5-16.4-10.4-17-20-.6-9.6,6.1-16.1,15-14.7,8.8,1.5,16.4,10.4,17,20Z" />
                        <path class="st4"
                            d="M167.3,207.7c1.1,5.4.2,9.8-2.2,10-2.3.2-5.2-4.1-6.3-9.4-1.1-5.4-.2-9.8,2.2-10,2.3-.2,5.2,4.1,6.3,9.4Z" />
                        <path class="st4"
                            d="M148.7,205.6c10.1,1.2,30.2-.1,33.6-2-2.5-9.7-14.5-20.7-25.3-19.3-9.8,1.3-8.3,21.2-8.3,21.2Z" />
                        <path class="st4"
                            d="M150.6,211.9c12.6.6,29,.3,33.7-1.5-.4,9.6-3,18.8-15.8,18.6-10.5-.1-17.9-17.1-17.9-17.1Z" />
                    </g>
                    <path class="st4"
                        d="M223.1,168.3c-18.9,0-31.4-9.3-32.1-9.8-2-1.5-2.4-4.3-.9-6.3,1.5-2,4.3-2.4,6.3-.9.2.2,15.1,11,35.8,7.1,2.4-.5,4.8,1.1,5.2,3.6.5,2.4-1.1,4.8-3.6,5.2-3.8.7-7.4,1-10.9,1Z" />
                    <path class="st4"
                        d="M142.9,160.6c-.5,0-1,0-1.5-.3-2.3-.8-3.5-3.4-2.7-5.7,2.4-6.6,6.3-10.9,11.7-12.8,9.8-3.4,20.3,3.2,20.8,3.5,2.1,1.3,2.7,4.1,1.4,6.2-1.3,2.1-4.1,2.7-6.2,1.4-2-1.3-8.4-4.2-13.1-2.6-2.7.9-4.7,3.3-6.2,7.3-.7,1.8-2.4,3-4.2,3Z" />
                    <path class="st4"
                        d="M178.2,236.2c-.1,0-.2,0-.4,0-.7-.2-1.1-.9-.9-1.6,0-.1.9-3,4.6-4.9,5.1-2.7,13-2.1,23.3,1.6.7.3,1.1,1,.8,1.7-.3.7-1,1.1-1.7.8-11.8-4.3-18-3.4-21-1.8-2.7,1.3-3.3,3.2-3.3,3.3-.2.6-.7,1-1.3,1Z" />
                    <g>
                        <g>
                            <path class="st10"
                                d="M135.9,231.3c-26.1,2.3-44.8,13.2-44.8,13.2,7.7-1.5,35.4,32.7,42.5,59.1,13.1-4.9,28.4-8.2,44.7-10.8-9.9-27.2-27.9-58-42.4-61.5Z" />
                            <path class="st3"
                                d="M135.9,231.3c-26.1,2.3-44.8,13.2-44.8,13.2,7.7-1.5,35.4,32.7,42.5,59.1,13.1-4.9,28.4-8.2,44.7-10.8-9.9-27.2-27.9-58-42.4-61.5Z" />
                        </g>
                        <g>
                            <path class="st10"
                                d="M135.9,231.3c-17.1-1.9-44.8,12.4-44.8,12.4-4.9,3.1-3.6,9-.9,11.5,2.6-3.7,31.2-13.3,42-14.6-5.4-5-.4-8.6,3.7-9.3Z" />
                            <path class="st0"
                                d="M135.9,231.3c-17.1-1.9-44.8,12.4-44.8,12.4-4.9,3.1-3.6,9-.9,11.5,2.6-3.7,31.2-13.3,42-14.6-5.4-5-.4-8.6,3.7-9.3Z" />
                        </g>
                    </g>
                    <path class="st4"
                        d="M110.7,273c-1.5,0-2.9-.7-3.8-2-3.3-5-1.2-12.6-.8-14.1.7-2.4,3.2-3.7,5.6-3,2.4.7,3.7,3.2,3,5.6-.7,2.5-.9,5.7-.3,6.6,1.4,2.1.8,4.9-1.3,6.2-.8.5-1.6.7-2.4.7Z" />
                </g>
            </g>
        </svg>
        <p class="texto-error">{{ errorAction }}</p>
        <div class="opciones">
            <button @click="copyToClipboard" v-if="canUseClipboard">{{ $t("shared.ui.buttons.copyToClipboard")
                }}</button>
            <button @click="selectAllDetails">{{ $t("shared.ui.buttons.selectAll") }}</button>
            <button @click="toggleDetails">{{ showDetails ? $t("shared.ui.buttons.hideDetails") :
                $t("shared.ui.buttons.showDetails") }}</button>
        </div>
        <pre v-if="showDetails" style="word-wrap: anywhere; white-space: pre-wrap;" ref="preDetails">
{{ errorDetails }}
    </pre>
    </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { AppError } from "../../services/errorHandling";
import { modalDefinedEmits, useModalBuilder } from "../../helpers/modal-building-helper";
import { toastSuccess } from "@/.shared/services/notification-service";
import { useIntl } from "@services/i18n";

const props = defineProps<{
    error: AppError
}>();

defineEmits([...modalDefinedEmits]);

const canUseClipboard = navigator.clipboard !== undefined;
const errorMessage = computed(() => props.error.message);
const errorDetails = computed(() => props.error.toJson());
const errorAction = computed(() => props.error.userAction);
const preDetails = ref<HTMLPreElement | null>(null);
const intl = useIntl();
const showDetails = ref(false);

onMounted(async () => {
    const builder = useModalBuilder();
    builder.setContext(getCurrentInstance()!);

    const cerrarButton = builder.standardButtons.addOk();
    cerrarButton.update((btn: any) => {
        btn.onClick = () => builder.close();
        btn.text = intl.i18n.t("shared.ui.buttons.close");
    });
});

function selectAllDetails() {
    window.getSelection()?.selectAllChildren(preDetails.value!);
}

async function copyToClipboard() {
    await navigator.clipboard.writeText(errorDetails.value);
    await toastSuccess("Detalles de error copiados al portapapeles");
}

function toggleDetails() {
    showDetails.value = !showDetails.value;
}
</script>

<style scoped lang="scss">
@import "@/styles/_themevars.scss";

.modal-error {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
}

p.texto-error {
    font-size: 1.275rem
}

.opciones {
    display: flex;
    gap: 8px;
}

.opciones button {
    border: none;
    border-radius: 5px;
    padding: 4px 16px;
}

pre {
    background: #f5f5f5;
    border-radius: 16px;
    padding: 8px 16px;
    margin-top: 16px;
    border: 1px solid #ccc;
}

svg {
    width: 160px;
    height: 160px;
    transition: transform .5s ease-out;

    #red-exclamation {
        animation: bounce .5s ease-out forwards;
        transform-origin: center center;

        .exclamation {
            opacity: 0;
            stroke-dasharray: 100;
            stroke-dashoffset: 100;
            animation: excl 1.5s ease forwards .5s;
        }

        .dot {
            opacity: 0;
            stroke-width: 30;
            stroke-linecap: round;
            animation: dot-fade .175s ease forwards .7s;
        }
    }
}

@keyframes excl {
    0% {
        stroke-dashoffset: 100;
    }

    10% {
        opacity: 1;
    }

    100% {
        opacity: 1;
        stroke-dashoffset: 0;
    }
}

@keyframes dot-fade {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes bounce {
    0% {
        opacity: 0;
        transform: scale(0.1);
    }

    50% {
        transform: scale(1.0);
    }

    75% {
        transform: scale(0.6);
    }

    100% {
        opacity: 1;
        transform: scale(0.9);
    }
}


//Otro svg
.st0 {
    opacity: .2;
}

.st0,
.st1,
.st2,
.st3 {
    fill: #fff;
}

.st4 {
    fill: #263238;
}

.st2 {
    opacity: .9;
}

.st5 {
    fill: #ebebeb;
}

.st6 {
    display: none;
}

.st7 {
    fill: #f5f5f5;
}

.st8 {
    opacity: 0;
}

.st3 {
    opacity: .6;
}

.st9 {
    fill: #e6e6e6;
}

.st10 {
    fill: lighten($base-accent, 20%);
}
</style>